import React from 'react';
import Scoreboard from './Scoreboard';
import './App.css';

function App() {
  return (
    <div className="app">
      <Scoreboard />
    </div>
  );
}

export default App;
